import ConnectedProfileSummary from './ProfileSummary';

export default ConnectedProfileSummary;
